import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { FETCH_AVAILABILITY, FETCH_AVAILABILITY_DID_YOU_MEAN, FETCH_AVAILABILITY_FAILURE, FETCH_AVAILABILITY_SUCCESS, FETCH_MORE_AVAILABILITY, FETCH_MORE_AVAILABILITY_FAILURE, FETCH_MORE_AVAILABILITY_SUCCESS } from '../actions/types';
import { formatStore, createFilters } from '../helpers/storeHelpers';
var initialState = {
  loading: false,
  error: null,
  distances: null,
  locations: null,
  availability: null,
  moreAvailability: null,
  moreAvailabilityLoading: false,
  safeMode: {
    stockCheckDisabled: null
  },
  moreAvailabilityError: null
};
export function formatDistance(distance) {
  return distance ? Number(distance).toFixed(1) : 0.1;
}
export function formatProducts(store) {
  return store.availability.map(function (product) {
    return {
      sku: product.sku,
      leadtime: store.messages[product.sku],
      stockedQuantity: product.quantityAvailable,
      requestedQuantity: product.quantityRequested
    };
  });
}
export function formatAvailability(response) {
  var withStoreInfo = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  return response.stores.map(function (store) {
    var messagesKey = !response.orderId ? store.availability[0].sku : 'collection_summary';
    return _objectSpread({
      products: formatProducts(store),
      availability: _objectSpread(_objectSpread({}, createFilters(store.availability)), store.messages[messagesKey]),
      storeId: store.store_id,
      storeDistance: formatDistance(store.distance)
    }, withStoreInfo && {
      storeInfo: formatStore(store.storeinfo)
    });
  });
}
export function getStoreDistances(response) {
  return response.stores.reduce(function (distances, data) {
    return _objectSpread(_objectSpread({}, distances), {}, _defineProperty({}, data.store_id, formatDistance(data.distance)));
  }, {});
}

function availabilityReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case FETCH_AVAILABILITY:
      return _objectSpread(_objectSpread({}, state), {}, {
        loading: true,
        error: null,
        distances: null,
        locations: null,
        availability: null,
        moreAvailability: null,
        moreAvailabilityError: null,
        moreAvailabilityLoading: false
      });

    case FETCH_AVAILABILITY_DID_YOU_MEAN:
      return _objectSpread(_objectSpread({}, state), {}, {
        loading: false,
        locations: action.payload
      });

    case FETCH_AVAILABILITY_FAILURE:
      return _objectSpread(_objectSpread({}, state), {}, {
        loading: false,
        error: action.error
      });

    case FETCH_AVAILABILITY_SUCCESS:
      return _objectSpread(_objectSpread({}, state), {}, {
        loading: false,
        availability: formatAvailability(action.payload),
        distances: getStoreDistances(action.payload),
        safeMode: action.payload.safeMode
      });

    case FETCH_MORE_AVAILABILITY:
      return _objectSpread(_objectSpread({}, state), {}, {
        moreAvailabilityLoading: true,
        moreAvailabilityError: false,
        moreAvailability: null
      });

    case FETCH_MORE_AVAILABILITY_FAILURE:
      return _objectSpread(_objectSpread({}, state), {}, {
        moreAvailabilityLoading: false,
        moreAvailabilityError: true
      });

    case FETCH_MORE_AVAILABILITY_SUCCESS:
      return _objectSpread(_objectSpread({}, state), {}, {
        moreAvailabilityLoading: false,
        moreAvailability: formatAvailability(action.payload, true)
      });

    default:
      return state;
  }
}

export default availabilityReducer;